module.exports = __webpack_public_path__ + "producr-dried fresh-grass-01.jpg?1448b9cbef824de9c04ea434a8703ff9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-01.jpg
// module id = 59
// module chunks = 0